import { useMemo } from "react"
import { useGetAccountNotificationsQuery } from "@apis/accounts/useAccounts"
import { AccountNotificationList } from "./AccountNotificationList"

type TAccountNotificationsProps = {
  prospect_guid: string | undefined
  account_id: string
  sectionTitle?: string
  showActionButtons?: boolean
}

export const AccountNotifications = ({
  prospect_guid,
  account_id,
  sectionTitle = "Account Notifications",
}: TAccountNotificationsProps) => {
  const {
    data = [],
    isError,
    error,
    isPending,
  } = useGetAccountNotificationsQuery({
    prospect_guid,
    account_id,
  })

  const timeStamp = (d?: string | null) => (d ? Date.parse(d) : 0)
  const sortedNotifications = useMemo(() => {
    return [...data].sort((a, b) => timeStamp(b.date) - timeStamp(a.date))
  }, [data])

  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <div className="tw:flex tw:items-center tw:justify-between">
        <h4 className="tw:text-xl tw:font-semibold">{`${sectionTitle} (${data.length})`}</h4>
      </div>

      <div className="tw:max-h-[200px] tw:overflow-y-auto">
        {isPending ? (
          <div className="tw:p-8 tw:text-center">Loading Notifications…</div>
        ) : isError ? (
          <div className="tw:p-8 tw:text-red-500">
            Error loading notifications: {(error as Error).message}
          </div>
        ) : (
          <AccountNotificationList
            account_id={account_id}
            prospect_guid={prospect_guid as string}
            account_notifications={sortedNotifications}
          />
        )}
      </div>
    </div>
  )
}
